/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id/versions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdVersions } from "./constants";
import type { GenerativeAiAgentIdVersionsParams, GenerativeAiAgentIdVersionsResult } from "./types";
import { isGenerativeAiAgentIdVersionsResult } from "./validators";

export const getDataTableGenerativeAiAgentIdVersions = reactQueryTableFetcherAdapter(
  generativeAiAgentIdVersions,
  (
    signal: AbortSignal,
    { appGroupId, id, limit = 10, start = 0, start_date, end_date }: GenerativeAiAgentIdVersionsParams
  ): Promise<GenerativeAiAgentIdVersionsResult> => {
    return fetch(
      `/generative_ai/agent/${id}/versions`,
      "GET",
      { limit, start, app_group_id: appGroupId, start_date, end_date },
      { signal }
    );
  },
  isGenerativeAiAgentIdVersionsResult
);
